import React from "react";
import PropTypes from 'prop-types';
import {Card, CardContent} from "@material-ui/core";

class AdminLocationCard extends React.PureComponent {
	static propTypes = {
		name: PropTypes.string.isRequired,
		description: PropTypes.string,
		modules: PropTypes.array,
		loadModuleTable: PropTypes.func,
		isLocModule: PropTypes.bool,
		subscriptionCounts: PropTypes.array
	};

	static defaultProps = {
		name: '',
		description: '',
		inStockQuantity: 0,
		modules: [],
		subscriptionCounts: []
	};

	// Helper function to find subscription count for a module
	getSubscriptionCount = (module) => {
		const { subscriptionCounts } = this.props;
		if (!subscriptionCounts || subscriptionCounts.length === 0) return null;

		// For modules, match on plan property
		// For subscriptions, match on id property
		const matchKey = this.props.isLocModule ? module.plan : module.id;

		const matchingCount = subscriptionCounts.find(item =>
			item.PlanName === matchKey
		);

		return matchingCount ? matchingCount.Count : 0;
	};

	render() {
		const {
			name,
			description,
			modules,
			loadModuleTable,
			isLocModule,
			subscriptionCounts
		} = this.props;

		return (
			<div style={{
				display: 'grid',
				gridTemplateColumns: isLocModule ? 'repeat(5, 1fr)' : 'repeat(5, 1fr)',
				gap: '24px',
				maxWidth: '100%',
				marginBottom: '30px',
				padding: '8px'
			}}>
				{modules.map((module) => {
					// Get subscription count for this module
					const count = this.getSubscriptionCount(module);

					return (
						<Card
							onClick={() => loadModuleTable(module)}
							key={module.id || module.name}
							style={{
								background: '#ffffff',
								boxShadow: '0 6px 15px rgba(0, 0, 0, 0.08)',
								borderRadius: '12px',
								width: '100%',
								height: '100%',
								transition: 'all 0.3s ease',
								cursor: 'pointer',
								overflow: 'hidden',
								position: 'relative',
								minHeight: isLocModule ? 'auto' : '120px'
							}}
							onMouseOver={(e) => {
								e.currentTarget.style.transform = 'translateY(-4px)';
								e.currentTarget.style.boxShadow = '0 10px 20px rgba(0, 0, 0, 0.12)';
							}}
							onMouseOut={(e) => {
								e.currentTarget.style.transform = 'translateY(0)';
								e.currentTarget.style.boxShadow = '0 6px 15px rgba(0, 0, 0, 0.08)';
							}}
						>
							{/* Status indicator bar with gradient */}
							<div style={{
								height: '6px',
								background: 'linear-gradient(90deg, #4a7aff 0%, #63a4ff 100%)',
								width: '100%'
							}} />

							<CardContent style={{
								padding: '20px',
								height: 'calc(100% - 6px)',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between'
							}}>
								<div style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'flex-start',
									marginBottom: '10px'
								}}>
									<div style={{
										display: 'flex',
										flexDirection: 'column',
										flex: 1
									}}>
										<p style={{
											fontSize: isLocModule ? '16px' : '18px',
											fontWeight: '600',
											margin: '0',
											marginBottom: '4px',
											color: '#444',
											fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
										}}
										   className="nav-text">
											{module.name ?? module.description}
										</p>

										{/*{module.name && module.description ? (*/}
										{/*	<span style={{*/}
										{/*		fontSize: '13px',*/}
										{/*		lineHeight: '1.5',*/}
										{/*		color: '#666',*/}
										{/*		overflow: 'hidden',*/}
										{/*		textOverflow: 'ellipsis',*/}
										{/*		fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'*/}
										{/*	}}>*/}
										{/*		{module.description}*/}
										{/*	</span>*/}
										{/*) : null}*/}
									</div>

									{module.price ? (
										<div style={{
											backgroundColor: 'rgba(74, 122, 255, 0.1)',
											color: '#4a7aff',
											padding: '4px 10px',
											borderRadius: '20px',
											fontSize: isLocModule ? '14px' : '15px',
											fontWeight: '600',
											marginLeft: '8px',
											whiteSpace: 'nowrap'
										}}>
											{module.price}
										</div>
									) : null}
								</div>

								{/* Subscription count with modern design */}
								{count !== null && (
									<div style={{
										display: 'flex',
										alignItems: 'center',
										marginTop: '12px'
									}}>
										<div style={{
											display: 'flex',
											alignItems: 'center',
											backgroundColor: 'rgba(76, 175, 80, 0.1)',
											color: '#4CAF50',
											borderRadius: '8px',
											padding: '4px 10px',
											fontSize: '13px'
										}}>
											{/* User icon SVG */}
											<svg
												width="16"
												height="16"
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
												style={{ marginRight: '6px' }}
											>
												<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
												<circle cx="12" cy="7" r="4"></circle>
											</svg>
											<span style={{ fontWeight: '600' }}>
												{count} {count === 1 ? 'Active Subscription' : 'Active Subscriptions'}
											</span>
										</div>
									</div>
								)}
							</CardContent>
						</Card>
					);
				})}
			</div>
		);
	}
}

export default AdminLocationCard;